import type { MessagingChannelsCopy } from './types';

export const ZH: MessagingChannelsCopy = {
  title: '消息渠道',
  description:
    '在你常用的聊天应用里和 IMAI 对话。连接一次，之后就能在那里给 IMAI 发消息。',
  privacy:
    '来自你已连接账号的消息会以你的身份在此工作区中运行，并消耗你的积分。',
  loading: '正在加载消息渠道',
  unavailable: '暂不可用',
  unavailableNote: '{channel} 尚未为 IMAI 配置。',
  connectedBadge: '已连接',
  cancel: '取消',

  addNumber: '添加号码',
  countryLabel: '国家/地区代码',
  countrySearch: '搜索国家或区号…',
  countryEmpty: '未找到国家。',
  numberLabel: '手机号码',
  continueActivation: '继续',
  editNumber: '更换号码',
  activateQr: '扫描后点击发送',
  activateHint: '打开{channel}后点击发送。',
  activationBack: '返回',
  activateButton: '打开{channel}',
  activateWaiting: '正在等待你的消息，{time} 后过期。',
  startAgain: '重新开始',
  remove: '移除',
  removeAria: '移除手机号码 {number}',
  removeTitle: '移除 {number}？',
  removeDescription:
    'IMAI 将不再在 iMessage 和 WhatsApp 上回复这个号码。你可以随时重新添加。',
  removeError: '无法移除号码，请重试。',

  errorInvalidNumber: '请输入有效的手机号码（包括区号）。',
  errorNumberTaken: '这个号码已被另一个 IMAI 账号使用。',
  errorRateLimited: '尝试次数过多，请稍后再试。',
  errorChannelUnavailable: '此方式暂不可用，请选择另一种。',
  errorSendFailed: '无法开始验证，请重试。',
  errorActivationExpired: '此次激活已过期，请重新开始。',

  noteSlack: '在你的 Slack 工作区里给 IMAI 发消息。',
  noteTeams: '在 Microsoft Teams 上给 IMAI 发消息。',
  noteTelegram: '在 Telegram 上和 IMAI 机器人聊天。',
  connect: '连接',
  connectAria: '连接 {channel}',
  connectError: '无法开始连接 {channel}，请重试。',
  connectedOn: '连接于 {date}',
  accountFallback: '你的 {channel} 账号',
  installSlack: '将 IMAI 添加到你的工作区',
  installTeams: '将 IMAI 添加到 Teams',
  openTelegram: '在 Telegram 中打开',
  disconnect: '断开连接',
  disconnectAria: '断开 {account} 与 {channel} 的连接',
  disconnectError: '无法断开 {channel}，请重试。',
  disconnectTitle: '断开 {channel}？',
  disconnectDescription:
    '来自 {account} 的消息将不再发送给 IMAI。你可以随时重新连接。',

  toastConnected: '已连接 {channel}',
  toastConnectedGeneric: '账号已连接',
  toastErrorExpired: '登录用时过长，请重新连接。',
  toastErrorInvalidState: '这个登录链接已失效，请重试。',
  toastErrorAccountTaken: '该账号已连接到另一位 IMAI 用户。',
  toastErrorNotMember: '你已不再是此工作区的成员。',
  toastErrorProvider: '登录未完成，请重新连接。',
  toastErrorGeneric: '无法连接账号，请重试。',
};
